import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import TagAPI from './api'

export default class Tag extends Model {
  static api = TagAPI.create(Tag)
  static readOnlyFields = ['id', 'name']

  constructor({ id = null, name } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
    })
  }

  static create(opts = {}) {
    return new Tag(opts)
  }

  static fromAPI(json = {}) {
    return new Tag(snakeToCamel(json))
  }

  copy() {
    return new Tag(this)
  }
}
